<div class="dialog">
  <mat-icon class="warning-icon secondary-color">error_outline</mat-icon>
  <p class="bigger align-center" [innerHTML]="text.header"></p>
  <small [innerHTML]="text.body"></small>
  <div>
    <button class="block float-right btn inverted" [ngClass]="getConfirmButtonClass(text.level)"
            style="margin-bottom:14px;" (click)="ok()">{{text.ok || 'oké'}}
    </button>
    <div class="clearFix"></div>
  </div>
</div>
